module.exports = __webpack_public_path__ + "img/virgin-islands.3b3def88.svg";